import React from 'react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import { Button, ButtonProps, HStack, Input, InputProps } from '@chakra-ui/react';

type QuantityInputProps = {
  inputProps: InputProps;
  incrementButtonProps: ButtonProps;
  decrementButtonProps: ButtonProps;
  disabled?: boolean;
};

export const QuantityInput = ({
  inputProps,
  incrementButtonProps,
  decrementButtonProps,
  disabled,
}: QuantityInputProps) => {
  return (
    <HStack m={'auto'} mr={0}>
      <Button
        variant={'incrementDecrementButton'}
        {...decrementButtonProps}
        color={'grey.900'}
        aria-label={'decrement'}
        isDisabled={disabled}
      >
        <MinusIcon h={'10px'} w={'10px'} />
      </Button>
      <Input w="50px" p={0} m={0} variant={'quantity'} {...inputProps} textAlign="center" isDisabled={disabled} />
      <Button
        variant={'incrementDecrementButton'}
        {...incrementButtonProps}
        color={'grey.900'}
        aria-label={'increment'}
        isDisabled={disabled}
      >
        <AddIcon h={'10px'} w={'10px'} />
      </Button>
    </HStack>
  );
};
